
/// <amd-module name="Build/DesignerExtensions/YamlSnippetForm/Components/RadioGroup" />
import * as React from "react";

import { getId } from "VSS/Core/Util/Object";
import { RadioButtonGroup, RadioButton, RadioButtonGroupDirection } from "VSSUI/RadioButton";
import { css } from "VSSUI/Util";
import { FormItem } from "VSSUI/FormItem";

import { YamlSnippetInput } from "Pipelines/Common/Library/Contracts/DataProvider";
import { EnhancedLabel } from "Build/DesignerExtensions/YamlSnippetForm/Components/EnhancedLabel";

export interface RadioGroupProps {
    inputDefinition: YamlSnippetInput;
    onValueChanged(name: string, value: string): void;
    getValue(name: string): string;
    direction?: RadioButtonGroupDirection;
}

/**
 * Radio buttons which includes a label
 */
export class RadioGroup extends React.Component<RadioGroupProps, {}> {
    private _groupId: string;
    private _initialValue: string;

    constructor(props: RadioGroupProps) {
        super(props);

        this._groupId = getId("yaml-snippet-panel-radiogroup");
        this._initialValue = props.getValue(props.inputDefinition.name);
    }

    public render(): JSX.Element {
        let selectedRadio = this.props.getValue(this.props.inputDefinition.name);
        let direction = this.props.direction ? this.props.direction : RadioButtonGroupDirection.Vertical;

        return <div className={"flex-column"}>
            <FormItem label={<EnhancedLabel title={this.props.inputDefinition.label} isRequired={this.props.inputDefinition.required} documentation={this.props.inputDefinition.helpMarkdown} />}>
                <RadioButtonGroup
                    className={css(this.props.inputDefinition.required && "required")}
                    selectedButtonId={selectedRadio}
                    onSelect={this._onChange}
                    id={this._groupId}
                    direction={direction}>
                    {this._radioButtons()}
                </RadioButtonGroup>
            </FormItem>
        </div>
    }
    
    private _radioButtons(): JSX.Element[] {
        let radioOptions: JSX.Element[] = [];
        Object.keys(this.props.inputDefinition.options).forEach(key => {
            radioOptions.push(<RadioButton key={key} id={key} text={this.props.inputDefinition.options[key]} />);
        });

        if (!this.props.inputDefinition.options[this._initialValue]) {
            radioOptions.push(<RadioButton key={this._initialValue} id={this._initialValue} text={this._initialValue} />);
        }

        return radioOptions;
    }

    private _onChange = (buttonId: string) => {
        this.props.onValueChanged(this.props.inputDefinition.name, buttonId);
    }
}
